export const formatLocalTime = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleString(); // Uses user's local timezone and preferences
}

export const formatDatePretty = (dateInput) => {
  const date = new Date(dateInput);

  const options = {
    month: 'short',   // "Jan", "Feb", "Mar", etc.
    day: 'numeric',   // 1-31
    year: 'numeric',  // 2025
    hour: 'numeric',
    minute: '2-digit',
    hour12: true      // AM/PM
  };

  return date.toLocaleString(undefined, options).replace(', ', ' · ');
}